import { render, staticRenderFns } from "./Sucursales_editar.vue?vue&type=template&id=82d4e0fe"
import script from "./Sucursales_editar.vue?vue&type=script&lang=js"
export * from "./Sucursales_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports